import React from 'react';
import PropTypes from 'prop-types';

import { SubmitButtonStyle } from './SubmitButtonStyle';

const SubmitButton = ({ theme, value, error, onClick, type }) => {
  return (
    <SubmitButtonStyle>
      <input
        type={type}
        className={`submit-element${theme ? ` ${theme}-theme` : ''}`}
        value={value}
        onClick={onClick}
      />
      {error && error.length ? <p className="submit-error">{error}</p> : null}
    </SubmitButtonStyle>
  );
};

SubmitButton.propTypes = {
  theme: PropTypes.string,
  value: PropTypes.string.isRequired,
  error: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  type: PropTypes.string,
};

SubmitButton.defaultProps = {
  theme: 'default',
  error: '',
  type: 'submit',
};

export default SubmitButton;
